import { salesforce } from './salesforce';

export const subscriptions = {
  salesforce,
};
